import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import { QuitPracticeDialogComponent } from '../quit-practice-dialog/quit-practice-dialog.component';
import { ViewImageDialogComponent } from '../../shared/components/view-image-dialog/view-image-dialog.component';
import { UserService } from '@app-services/user/user.service';
import { FirebaseService } from '@app-services/firebase/firebase.service';
import { apisDataCacheKeys } from '@app-constants/app.constants';
import * as moment from 'moment';
import { environment } from '@app-environments/environment';
import { UserFeedbackPopupComponent } from '../../shared/components/user-feedback-popup/user-feedback-popup.component';

@Component({
  selector: 'app-topic-summary-details',
  templateUrl: './topic-summary-details.component.html',
  styleUrls: ['./topic-summary-details.component.css']
})
export class TopicSummaryDetailsComponent implements OnInit {
  defaultTopicSammary: number = 0;
  updatedIndex = 0;
  disablePrev:boolean= true;
  disableNext:boolean= false;
  completedCount = 0;
  userLikeStatus: boolean = false;
  userDislikeStatus: boolean = false;

  topicSummaryList = [];
  questionIds = [];
  topicId;
  ViewMoreStatus: boolean = false;
  allTopicsSummeryProgress: any;
  selectedFlashCardData:any;
  questionProgess: any;
  isAllRevisionQuesionsCompleted:any;
  interval:any;
  timeSpent:any =0;
  userData: any;


  constructor(public dialog: MatDialog,
    public router: Router, public selfLearnService: SelfLearnService, public spinner:NgxSpinnerService,private firebaseService: FirebaseService,private userService: UserService) {
  }

  ngOnInit(): void {
   
    // this.userData = JSON.parse(
    //   localStorage.getItem(apisDataCacheKeys.userDetails)
    // );
    localStorage.removeItem('isItFromVideoSolution')
    this.selectedFlashCardData = JSON.parse(localStorage.getItem('SelectedFlashcardData'));
    console.log(this.selectedFlashCardData);
    this.getFlashcardsAndQuestions();
    if(this.selfLearnService.isFromLearn()){this.sendLsqData()}
    this.startTimer();
  }
  startTimer() {
    this.interval = setInterval(() => {
     // if(!this.isCurrentQuestionSubmitted)
           this.timeSpent++;
    },1000)
  }

  ViewMoreButton() {
    this.ViewMoreStatus = !this.ViewMoreStatus;
  }

  prevTopic(){
    this.ViewMoreStatus = false;
    if (this.defaultTopicSammary == 0){
      this.disablePrev = true;
    }else{
      this.disableNext = false;
      this.defaultTopicSammary = this.defaultTopicSammary - 1;
    } 
    clearInterval(this.interval)
    this.timeSpent =0;
    this.startTimer();

  }

  nextTopic(){
    this.ViewMoreStatus = false;
    this.updatedIndex = this.defaultTopicSammary;
    this.updateTopicSummaryProgress(true);
    let lastTopicSummary = (this.topicSummaryList.length) - 1;
    if (lastTopicSummary >= this.defaultTopicSammary){
      if(this.defaultTopicSammary != lastTopicSummary){
      this.defaultTopicSammary = this.defaultTopicSammary + 1;
      }else{
        if(this.questionIds.length <=0){
          this.disableNext = true;
            this.router.navigate([`selfLearn-V2/revise-completion`]);
        }
        else{
          this.defaultTopicSammary = this.defaultTopicSammary + 1;    
        }
      }

      this.disablePrev = false;
    }else{
      this.disableNext = true;
    }
    if(this.defaultTopicSammary == this.topicSummaryList.length && this.questionIds.length>0){this.startRevision();}
    clearInterval(this.interval)
    this.timeSpent =0;
    this.startTimer();
  }

  getFlashcardsAndQuestions(){
    this.spinner.show();
    this.selfLearnService.getFlashcardsAndQuestions().subscribe((resp:any) => {
      if(resp?.data){
        this.topicSummaryList = resp?.data?.flashcards;
        this.questionIds = resp?.data?.questionIds;
        this.topicId = resp?.data?.parent?.topicId;
        this.spinner.hide();
        this.getTopicSummaryProgress();
        this.getTopicSummaryAndQuestions();
        this.setPreviousAndNextButtons();
      }
    })
  }

  getTopicSummaryProgress(){
    this.spinner.show()
    this.selfLearnService.getTopicSummaryProgress().subscribe((resp:any) => {
      const topic = resp?.data?.filter((element:any) => this.topicId == element.topicId);
      if(topic){this.completedCount = topic[0]?.count || 0}
      this.spinner.hide();
      });
  }

  navigateToNewTopic(){
    let gotoIndex = 0;
    let isFristTime : boolean = true;
    this.topicSummaryList.map((element,row) => {
      if((!element.completed || element.completed == false) && isFristTime){
        gotoIndex = row;
        isFristTime = false;
      }
    });
    this.defaultTopicSammary = (isFristTime) ? (this.topicSummaryList.length -1) : gotoIndex;
  }

  getTopicSummaryAndQuestions(){
    this.selfLearnService.getTopicSummaryAndQuestions().subscribe((resp:any) => {
      this.topicSummaryList = this.topicSummaryList.map((item) => {
        const found = resp?.data?.flashcards.find((element:any) => item.flashcardId == element.flashcardId);
        if(found){
          item['completed']= found.isCompleted;
          item['isBookmarked'] = found.isBookmarked;
          item['isLiked'] = found.isLiked;
          item['isDisLiked'] = found.isDisLiked;
          item['likedCount'] = found.likedCount;

        }
        return {...item}
      });
      this.questionProgess = resp?.data?.questions;
      this.isRevisionQuestionsCompleted()
      this.navigateToNewTopic();
    })
  }

  setPreviousAndNextButtons(){
    if (this.defaultTopicSammary != 0){
      this.disablePrev = false;
    }
    if (this.topicSummaryList.length < 1){
      this.disableNext = true;
    }
  }

  getTopicName(){
    return localStorage.getItem("selfLearnSelectedTopicName");
  }

  userLike() {
    this.topicSummaryList[this.defaultTopicSammary].isLiked = true;
    this.topicSummaryList[this.defaultTopicSammary].isDisLiked = false;
    this.userLikeStatus = !this.userLikeStatus;
    let payload = this.constructpayloadForLikeAndDisLike();
    this.selfLearnService.updateTopicSummaryProgress(payload).subscribe((resp:any) => {

    })
  }
  userDislike() {
    this.topicSummaryList[this.defaultTopicSammary].isLiked = false;
    this.topicSummaryList[this.defaultTopicSammary].isDisLiked = true;
    this.userDislikeStatus = !this.userDislikeStatus;
    let payload = this.constructpayloadForLikeAndDisLike();
    this.selfLearnService.updateTopicSummaryProgress(payload).subscribe((resp:any) => {

    })
    const dialogRef = this.dialog.open(UserFeedbackPopupComponent, {
      data: {
        assetType:"flashcard",
        assetId: this.topicSummaryList[this.defaultTopicSammary]  
    }
    });

    dialogRef.afterClosed().subscribe(() => {
    });
  }

  quitRevision(){
    const config: MatDialogConfig = {
      //width: '388px',
      // width: '620px',
      panelClass: ['qiut-practice-modal', 'mweb-stiky-bottom'],
      data: {
        topicName: this.selfLearnService.getTopicName(),
        type: "Quit Revision",
      }
    };
    this.dialog.open(QuitPracticeDialogComponent, config);
  }

  getMedia(item){
    return item?.titleMedia.replaceAll('https', 'http');
  }

  onTopicSelected(index){
    this.ViewMoreStatus = false;
    this.updatedIndex = this.defaultTopicSammary;
    this.updateTopicSummaryProgress(true);
    this.defaultTopicSammary = index;
    if(this.defaultTopicSammary == this.topicSummaryList.length){this.startRevision();}
    else{
      this.setPreviousAndNextButtons();
    }
  }

  updateTopicSummaryProgress(isCompleted){
    let payload = this.constructJsonForTopicProgress(isCompleted);
    this.selfLearnService.updateTopicSummaryProgress(payload).subscribe((resp:any) => {
      if(resp){this.topicSummaryList[this.updatedIndex].completed = true}
      this.getTopicSummaryProgress();
    })
  }
  bookMarkSummaryProgress(isBookMarked:any){
    // this.topicSummaryList[this.defaultTopicSammary].isBookmarked =isBookMarked
    let payload = this.constructJsonForTopicProgressBookMark(isBookMarked);
    this.selfLearnService.updateTopicSummaryProgress(payload).subscribe((resp:any) => {
      if(resp){
        this.topicSummaryList[this.defaultTopicSammary].isBookmarked = isBookMarked;
        this.topicSummaryList[this.updatedIndex].isBookmarked = isBookMarked
      }
      this.getTopicSummaryProgress();
    })
  }

  constructJsonForTopicProgress(isCompleted){
    const flashCardDetail = this.topicSummaryList[this.defaultTopicSammary]
    return {
      "examId": Number(this.selfLearnService.getCmsExamID()),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": Number(this.selfLearnService.getSubjectId()),
      "chapterId": Number(this.selfLearnService.getChapterId()),
      "chapterName": this.selfLearnService.getChapterName(),
      "topicId": Number(this.selfLearnService.getTopicId()),
      "topicName": this.getTopicName(),
      "flashCards": [
        {
          "flashCardId": flashCardDetail?.flashcardId,
          "flashCardName": flashCardDetail?.title,
          "flashCardTypeId": flashCardDetail?.flashcardTypeId,
          "isCompleted": isCompleted,
          "subTopicId": 0,
          "timeTakenInSecs": this.timeSpent,
        }
      ]
    };
  }
  constructJsonForTopicProgressBookMark(isBookMarked:any){
    const flashCardDetail = this.topicSummaryList[this.defaultTopicSammary]
    return {
      "examId": Number(this.selfLearnService.getCmsExamID()),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": Number(this.selfLearnService.getSubjectId()),
      "chapterId": Number(this.selfLearnService.getChapterId()),
      "chapterName": this.selfLearnService.getChapterName(),
      "topicId": Number(this.selfLearnService.getTopicId()),
      "topicName": this.getTopicName(),
      "isBookmarked": isBookMarked,
      "flashCards": [
        {
          "flashCardId": flashCardDetail?.flashcardId,
          "flashCardName": flashCardDetail?.title,
          "flashCardTypeId": flashCardDetail?.flashcardTypeId,
          "isBookmarked": isBookMarked,
          "subTopicId": 0,
          "timeTakenInSecs": 0
        }
      ]
    };
  }

  constructpayloadForLikeAndDisLike(){
    const flashCardDetail = this.topicSummaryList[this.defaultTopicSammary]
    return {
      "examId": Number(this.selfLearnService.getCmsExamID()),
      "gradeId": this.selfLearnService.getGradeId(),
      "subjectId": Number(this.selfLearnService.getSubjectId()),
      "chapterId": Number(this.selfLearnService.getChapterId()),
      "chapterName": this.selfLearnService.getChapterName(),
      "topicId": Number(this.selfLearnService.getTopicId()),
      "topicName": this.getTopicName(),
      "flashCards": [
        {
          "flashCardId": flashCardDetail?.flashcardId,
          "flashCardName": flashCardDetail?.title,
          "flashCardTypeId": flashCardDetail?.flashcardTypeId,
           "isLiked": this.topicSummaryList[this.defaultTopicSammary].isLiked,
           "isDisLiked": this.topicSummaryList[this.defaultTopicSammary].isDisLiked,
          "subTopicId": 0,
          "timeTakenInSecs": 0
        }
      ]
    };
  }

  startRevision(){
      // localStorage.setItem('subtopicCount', topicData.subtopicCount);
      // localStorage.setItem('selfLearnSelectedTopicId', this.parcticeCardData.topicId);
      // localStorage.setItem("selfLearnSelectedTopicName", this.parcticeCardData.topicName);
      // localStorage.setItem('currentLevel', this.parcticeCardData.levelsInProgress);
      this.router.navigate([`selfLearn-V2/revise-questions`]);
      // this.dialog.open(TestInstructionDialogComponent, { width:'768px', panelClass: 'test-instruction-modal' });
      // this.dialogRef.close(true);
      // this.dialog.open(StartTestDialogComponent, { width: '768px', panelClass: ['start-test-modal', 'mweb-stiky-bottom'] });
  }
  isRevisionQuestionsCompleted(){
    if(this.questionIds.length == this.questionProgess.length){
      this.isAllRevisionQuesionsCompleted =true;
    }else{
      this.isAllRevisionQuesionsCompleted = false;
    }
  }
  openViewImageDialog(itemImage:any) {
    console.log(itemImage.titleMedia);
    const config: MatDialogConfig = {
      width: 'auto',
      panelClass: ['revise-image-view-modal'],
      data: {
        titleMedia: itemImage.titleMedia,
      },
    };
    const dialogRef = this.dialog.open(
      ViewImageDialogComponent,
      config
    );
    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  sendLsqData(){
    let payload = {
      data: {
        flashcard_subject: this.selfLearnService.getSubjectName(),
        flashcard_chapter: this.selfLearnService.getChapterName()
      },
      landingPage: "LSQ_CUSTOM_EVENTS"
    };

    let firebasePayload = {
      "ActivityDateTime": moment().utc().format("YYYY-MM-DD HH:mm:ss"),
      "ActivityEvent": 263,
      "Fields": {},
      "FirstName": this.userData?.firstName,
      "LastName": this.userData?.lastName,
      "environment": environment?.branch,
      "phone": this.userData?.phone,
      "productId": 1,
      "type": "Activity"
    };

    // this.selfLearnService.callTrackingAPI2(payload, 'Act_Self_Learn_Flashcards').subscribe((data) => {
    //   console.log(data);
    // });

    this.firebaseService.getSqsValue().then((firebaseRSP) => {
      firebasePayload.Fields = {
        mx_Custom_1: this.selfLearnService.getSubjectName(),
        mx_Custom_2: this.selfLearnService.getChapterName()
      }
      this.userService.sendSQSMsg(firebaseRSP?.access_key, firebaseRSP?.secret_key, firebaseRSP,firebasePayload);
    }).catch((e) => {
      console.log(e);
    });


  }

}
